export enum HelpText {
    menuOrder = 'admin.store.statistics.orders',
    menuCatalog = 'admin.store.settings.catalog.title',
    menuLocation = 'admin.store.locations.text',
    menuSettings = 'admin.store.settings.title',
    menuStatistics = 'admin.store.statistics.title',
    menuUser = 'admin.store.users.header',
    menuSubscription = 'admin.store.setting.billing',
    menuCustomers = 'admin.store.customers.customers',
    menuBilling = 'admin.store.setting.billing',
    menuPartner = 'admin.global.partnerProgram.label',
    menuRegisterStore = 'admin.register.registerTitle',
    menuSharePreview = 'admin.store.share.sharePreview',
    menuCatalogOffer = 'admin.store.catalogOffer',
    menuManageByExcel = 'admin.store.catalogManageByExcel',
    tableManageByExcel = 'admin.store.tableHelpText',
    menuCatalogOptionsByExcel = 'admin.store.menuCatalogOptionsByExcel',
    menucatalogChangeAndTranslateLable = 'admin.store.catalog.importTranslation',
    menucatalogImportFromPhoto = 'admin.store.catalog.importImage',
    menuCatalogCategory = 'admin.store.catalogCategory',
    menuCatalogPriceVariants = 'admin.store.catalog.priceVariants',
    menuCatalogOptionGroup = 'admin.store.catalog.catalogOptionGroup',
    menuSettingsStoreDetails = 'admin.store.settings.details.title',
    menuSettingsStoreOrdering = 'admin.store.statistics.orderCapture',
    menuSettingsMultipleStore = 'admin.store.setting.multiStore.title',
    menuSettingsStorePayment = 'admin.store.settings.paymentProviders.title',
    menuSettingsStorePickup = 'admin.store.orderDeliveryMethod.pickup',
    menuSettingsStoreDelivery = 'admin.store.settings.delivery.title',
    menuSettingsStoreLocations = 'admin.store.settings.tableOrdering.title',
    menuSettingsStoreCatalog = 'admin.store.settings.catalog.title',
    menuSettingsStoreOrderingRule = 'admin.store.setting.orderingRules.title',
    menuSettingsStoreSchedules = 'admin.store.settings.schedules.title',
    menuSettingsStoreMarketing = 'admin.store.settings.marketing.title',
    menuSettingsStoreDiscountVouchers = 'admin.store.settings.discountVouchers.title',
    menuSettingsStoreDomainsAndApps = 'admin.store.setting.domainsApps.title',
    menuSettingsStoreIntegrations = 'admin.store.setting.integrations.title',
    menuSettingsStoreBranding = 'admin.store.settings.branding.title',
    menuSettingsStoreLoyalty = 'admin.store.settings.loyalty.title',
    menuSettingsStoreOrderManagement = 'admin.store.settings.orderManagement.title',
    menuReservations = 'admin.store.statistics.reservations',
    menuSettingsReservations = 'admin.store.statistics.reservations',
    menuEvents= 'admin.store.events.event',
    menuBookingTier = '',
    enableCustomerAuthentication = '',
    displayPickupAddress = '',
    delieveryZoneRestriction = '',
    openTabOrdering = '',
    requestOrderDateUpfront = '',
    maximumItemsPerSlot = '',
    requestDesiredTime = '',
    DesiredTimeInMinutes = '',
    SlotDurationInMinutes = '',
    defaultOrderingMode = '',
    apps = '',
    mynext = '',
    hubrise = '',
    powersoft = '',
    eposDirect = '',
    poster = '',
    eposNow = '',
    jcc = '',
    stripe = '',
    rms = '',
    trust = '',
    paymentsense = '',
    payabl = '',
    vivawallet = '',
    square = '',
    paypal = '',
    other = '',
    globalpay = '',
    mollie = '',
    fygaro = '',
    apcopay = '',
    epay = '',
    hobex = '',
    ryft = '',
    abapayway = '',
    rootline = '',
    solidgate = '',
    emerchantpay = '',
    neosoft = '',
    countAgainstSlotCount = '',
    optiongroup = '',
    allowordering = '',
    wooDelivery = '',
    paymentOptions = '',
    standalonePayments = '',
    openTableOnAdminOrder = '',
    manageStock = '',
    addOptionGroup = '',
    facebookPixel = '',
    googleAnalytics = '',
    flexDelivery = '',
    shopify = '',
    customIntegration = '',
    inheritParentStoreCatalog = '',
    inheritCatalog = '',
    inheritSchedules = '',
    menuStandalonePayment = '',
    paymentRequests = '',
    sunSoft = '',
    twinSoft = '',
    hit = '',
    googleTagManager = '',
    wolt = '',
    orderFulfilment = '',
    MemberAuthentication = '',
    ClearBasketInactivity = '',
    TermsConditionsAcceptance = '',
    EnableBillingAddress = '',
    BuzzerNumber = '',
    TimeRangeMinutes = '',
    AllowOrderStore = '',
    AllowOrderDeletion = '',
    DetailedOrderReceipt = '',
    AutomaticallyAcceptOrders = '',
    PayLaterOption = '',
    AllowCustomerReservations = '',
    DefaultReservationDduration = '',
    ReservationSchedule = '',
    CustomerReservationSchedule = '',
    DesiredTimeIntervals = '',
    ServiceCharge = '',
    LocationType = '',
    DefaultCatalogView = '',
    SameDayOrdering = '',
    OrdersPerSlot = '',
    DisplayDesiredDate = '',
    DesiredDateTime = '',
    Domains = '',
    NewUserDiscount = '',
    iotsoftIntegration = '',
    witecIntegration = '',

}
